
const LOGICAL_STACK_BEGIN_MARKER = ''
const LOGICAL_STACK_END_MARKER = ''

const LOGICAL_STACK_SEPARATOR = '›'
// '⋅' '↘' ':' '•' '›'

const LOGICAL_STACK_MODULE_MARKER = ''

const LOGICAL_STACK_OPERATION_MARKER = ''
// '…'

const LOGICAL_STACK_SEPARATOR_NON_ADJACENT = '…'

export {
	LOGICAL_STACK_BEGIN_MARKER,
	LOGICAL_STACK_END_MARKER,
	LOGICAL_STACK_MODULE_MARKER,
	LOGICAL_STACK_SEPARATOR,
	LOGICAL_STACK_OPERATION_MARKER,
	LOGICAL_STACK_SEPARATOR_NON_ADJACENT,
}
